// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetBrandTypeService = {};
// console.log("🚀 ~ AssetBrandTypeService:", AssetBrandTypeService);

AssetBrandTypeService.postAssetBrandType = function (data) {
  return lossClient({
    url: "/AssetBrandType/add",
    method: "post",
    data: data,
  });
};

AssetBrandTypeService.getAssetBrandTypeList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // console.log(
  //   "🚀 ~ file: AssetBrandTypeService.js:17 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetBrandTypeService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetBrandType/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetBrandTypeService.getAssetBrandTypeApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  // console.log(
  //   "🚀 ~ file: AssetBrandTypeService.js:45 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetBrandTypeService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetBrandType/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetBrandTypeService.putAssetBrandTypeApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { userId: data.userId, Note: data.note, BrandTypeId: data.BrandTypeId }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { UserId: data.userId, Note: data.note, BrandTypeId: data.BrandTypeId }
      : data.approvalFlag == "approve"
      ? { userId: data.userId, Note: data.note, BrandTypeId: data.BrandTypeId }
      : { userId: data.userId, Note: data.note, BrandTypeId: data.BrandTypeId };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/AssetBrandType/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.AssetBrandId,
    },
    data: requestDataValidation,
  });
};

AssetBrandTypeService.putAssetBrandTypeRequest = function (data) {
  // console.log("🚀 ~ data:", data);

  var bodyRequest = {
    BrandTypeId: data.BrandTypeId,
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
  // console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/AssetBrandType/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.AssetBrandId,
    },
    data: bodyRequest,
  });
};

AssetBrandTypeService.getAssetBrandTypeDetail = function (data) {
  return lossClient({
    url: `/AssetBrandType/${data.id}`,
    method: "get",
  });
};

AssetBrandTypeService.updateAssetBrandType = function (data) {
  // console.log("🚀 ~ data:", data);
  const { AssetBrandId, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/AssetBrandType/edit",
    method: "put",
    headers: {
      "x-requestId": data.AssetBrandId,
    },
    data: requestBody,
  });
};

AssetBrandTypeService.deleteAssetBrandType = function (data) {
  // console.log("🚀 ~ AssetBrandTypeService.deleteAssetBrandType ~ data:", data);
  const { AssetBrandId, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/AssetBrandType/Delete",
    method: "delete",
    headers: {
      "x-requestid": data.AssetBrandId,
    },
    data: requestBody,
  });
};

export default AssetBrandTypeService;
